// import { domainTypes } from './scopes.config'

export const handleViewPermission = (key: string) => {
  return [`view_${key}`, `view_all_${key}`, `view_team_${key}`]
}

export interface RouterMenuProps {
  id: number
  path?: string
  parent_id: null | number
  icon?: string
  label: string
  key: string
  slug?: string
  permission_slugs: string | string[]
  slugOptions?: string[]
  breadcrumb?: string[]
  isDetails?: boolean
  isExpanded?: boolean
  isSidebarMenu?: boolean
  hasChild?: boolean
  hasDivider?: boolean
  pathOverride?: string
  publicPermission?: boolean
}

// dashboard

const LOGIN: RouterMenuProps = {
  id: 0,
  path: '/login',
  parent_id: null,
  permission_slugs: [],
  label: 'Login',
  key: 'login',
}

const FORGET_PASSWORD: RouterMenuProps = {
  id: 0,
  path: '/forget-password',
  parent_id: null,
  permission_slugs: [],
  label: 'Forget Password',
  key: 'forget_password',
}
const RESET_PASSWORD: RouterMenuProps = {
  id: 0,
  path: '/reset-password/:token',
  parent_id: null,
  permission_slugs: [],
  label: 'Reset Password',
  key: 'reset_password',
}
const CHANGE_PASSWORD: RouterMenuProps = {
  id: 0,
  path: '/change-password',
  parent_id: null,
  permission_slugs: [],
  label: 'Change Password',
  key: 'change_password',
}
// dashboard

const DASHBOARD: RouterMenuProps = {
  id: 1,
  path: '/dashboard',
  parent_id: null,
  icon: 'dashboard-icon',
  label: 'Dashboard',
  key: 'dashboard',
  permission_slugs: [],
  isSidebarMenu: true,
}
// staff
// const CREATE_STAFF: RouterMenuProps = {
//   id: 201,
//   parent_id: null,
//   icon: 'assign-team',
//   label: 'Staff Onboarding',
//   path: '/add-staff',
//   key: 'CREATE_STAFF',
//   slug: 'CREATE_STAFF',
//   isSidebarMenu: false,
//   permission_slugs: [],
// }
const STAFF_DIRECTORY: RouterMenuProps = {
  id: 2,
  parent_id: null,
  icon: 'customer-icon',
  label: 'Staff Directory',
  path: '/staffs',
  key: 'STAFF_DIRECTORY',
  slug: 'STAFF_DIRECTORY',
  isSidebarMenu: true,
  permission_slugs: [],
}
const USER_PROFILE: RouterMenuProps = {
  id: 8118,
  path: '/profile',
  parent_id: null,
  icon: 'cart-icon',
  label: 'reciept',
  key: 'user-profile',
  permission_slugs: [],
}

//Contacts

// const ADDRESS_BOOK: RouterMenuProps = {
//   id: 3,
//   path: '/address-book',
//   parent_id: null,
//   label: 'Address Book',
//   key: 'address-book',
//   permission_slugs: [],
//   isSidebarMenu: true,
// }
// const ADMIN_USER_DETAILS: RouterMenuProps = {
//   id: 2,
//   path: '/admin-user/:id',
//   parent_id: null,
//   label: 'Administrators',
//   key: 'admin-user',
//   permission_slugs: [],
//   isSidebarMenu: true,
// }
// Note : The arrangements of below "router_config" object will reflect in Sidebar
export const router_config: { [key: string]: RouterMenuProps } = {
  DASHBOARD,
  // CREATE_STAFF,
  STAFF_DIRECTORY,
  // ADDRESS_BOOK,
  // ADMIN_USER_DETAILS,
  LOGIN,
  FORGET_PASSWORD,
  RESET_PASSWORD,
  CHANGE_PASSWORD,
  USER_PROFILE,
}
